import { todayDate } from '../../calendar/helpers';

const timeStringToDate = (time: string, date: Date = todayDate()): Date => {
  const [hh, mm] = time.split(':').map(t => parseInt(t, 10));
  date.setHours(hh, mm);
  return date;
};

export default timeStringToDate;
